import axios from "axios"
import { LessonVarieties, LessonVariety, Type } from "shared/types/moduleTypes"
import { ClassResponse, StudentAssignmentResponse, StudentNote } from "shared/types/studentTypes"

/**
 * Get all classes that student is part of
 */
function getClasses(): Promise<ClassResponse[]> {
    return axios.get("/api/student/classes")
        .then((response) => response.data)
}

/**
 * Get all assignments for a particular class
 */
function getAssignments({ classId, assignmentType }: { classId: string, assignmentType: "stemsims" | "science35" | "all" }): Promise<StudentAssignmentResponse[]> {
    const assignmentTypes : LessonVariety[] = assignmentType === "stemsims" ? 
        ["Guided", "Pure Inquiry", "Topic"] : assignmentType === "science35" ? ["Review"] : LessonVarieties.map(lv => lv) 
    return axios.get("/api/student/assignments", {
        params: { classId, assignmentTypes }
    })
        .then((response) => response.data)
}

/**
 * Get a particular assignment
 */
function getAssignment(assignmentId: string): Promise<StudentAssignmentResponse> {
    return axios.get(`/api/assignments/${assignmentId}`, {
        params: { assignmentId }
    }).then((response) => response.data)
}

interface SaveNotesProps {
    submissionId: string
    moduleName: string
    type: Type
    assessmentNumber: number
    assessmentId: string
    questionNumber: number
    notes: string
}

export const getNotes = async ({ studentAssessmentId } : { studentAssessmentId: string }): Promise<StudentNote[]> => {
    if (!studentAssessmentId) return null
    const res = await axios.get("/api/student/assignments/notes", { params: { studentAssessmentId }})
    return res.data
}

export const saveNotes = async (data: SaveNotesProps) => {
    const res = await axios.post("/api/student/assignments/notes", data)
    return res.data
}

const students = {
    getClasses,
    getAssignments,
    getAssignment,
}

export default students
